import { useEffect } from 'react';

import optimizeContentfulImageUrl from 'common/components/Contentful/optimizeContentfulImageUrl';

import { useWindowSize } from './useWindowSize';

export function preloadAssets(assets) {
  (Array.isArray(assets) ? assets : [assets])
    .map((asset) =>
      optimizeContentfulImageUrl(
        asset?.fields?.file?.url,
        asset?.fields?.file?.contentType
      )
    )
    .filter(Boolean)
    .forEach((url) => {
      const image = new Image();
      image.src = url;
    });
}

export function preloadCTAs(ctas) {
  preloadAssets(
    (Array.isArray(ctas) ? ctas : [ctas])
      .map((cta) => cta?.fields?.icon)
      .filter(Boolean)
  );
}

export function preloadMedia(media, isDesktop) {
  for (const { fields } of Array.isArray(media) ? media : [media]) {
    preloadAssets(fields.icon);
    preloadCTAs(fields.callToAction);

    if (isDesktop) {
      preloadAssets(fields.desktop);
    } else {
      preloadAssets(fields.mobile);
    }
  }
}

export function usePreload(func, ref) {
  const { isDesktop } = useWindowSize();

  useEffect(() => {
    if (func && ref?.current) {
      const onScroll = () => {
        const y = ref?.current?.getBoundingClientRect()?.y;

        if (y <= window.innerHeight * 2) {
          window.removeEventListener('scroll', onScroll);
          try {
            func(isDesktop);
          } catch (ex) {
            console.warn('Failed to preload image');
          }
        }
      };

      window.removeEventListener('scroll', onScroll);
      window.addEventListener('scroll', onScroll, { passive: true });
      return () => window.removeEventListener('scroll', onScroll);
    }
  }, [func, ref]);
}
